module.exports = __webpack_public_path__ + "static/media/meditation-timer-2.a5096de7.jpg";